export const name = {
  label: {
    first: 'First name',
    last: 'Last name',
    middle: 'Middle name',
    initialOnly: 'Initial only',
    noFirst: 'No first name',
    noMiddle: 'No middle name',
    other: 'Other',
    suffix: 'Suffix',
    optional: '(Optional)',
    jr: 'Jr',
    sr: 'Sr',
    i: 'I',
    ii: 'II',
    iii: 'III',
    iv: 'IV',
    v: 'V',
    vi: 'VI',
    vii: 'VII',
    viii: 'VIII',
    ix: 'IX',
    x: 'X',
  },
  pvq: {
    label: {
      lettersOnly: 'Letter(s) Only',
      middleUnknown: 'I Don\'t Know',
      noFirst: 'No First Name',
      noMiddle: 'No Middle Name',
      first: 'First Name',
      last: 'Last Name',
      middle: 'Middle Name',
      other: 'Other',
      suffix: 'Suffix',
      optional: '(Optional)',
      jr: 'Jr',
      sr: 'Sr',
      i: 'I',
      ii: 'II',
      iii: 'III',
      iv: 'IV',
      v: 'V',
      vi: 'VI',
      vii: 'VII',
      viii: 'VIII',
      ix: 'IX',
      x: 'X',
      none: 'None',
      unknown: 'I Don\'t Know',
      aliasornickname: 'Alias or Nickname',
    },
    description: {
      other: 'Please provide other suffix.',
      unknown: 'Please provide explanation for why you don\'t know.',
    }
  }
};
